// Risk-scoring primitives — spec 12 §4. 5×5 matrix:
//   score = likelihood × severity, range 1–25.
//   band:
//     1–5  → low
//     6–11 → med
//     12–19→ high
//     20–25→ severe
//
// Inherent vs residual: inherent = before controls, residual = after.
// The card surfaces both; the heatmap and filters use residual.

export type Likelihood = 1 | 2 | 3 | 4 | 5
export type Severity = 1 | 2 | 3 | 4 | 5
export type RiskBand = 'low' | 'med' | 'high' | 'severe'

export function riskScore(l: Likelihood, s: Severity): number {
  return l * s
}

export function bandFor(score: number): RiskBand {
  if (score >= 20) return 'severe'
  if (score >= 12) return 'high'
  if (score >= 6) return 'med'
  return 'low'
}

// Shape-erased scoring helpers — useful inside filters that don't want
// to drag the full EventRisk type in. The fields they read are stable
// across v2 spec revisions.
export interface ScorableRisk {
  inherentL: Likelihood
  inherentS: Severity
  residualL: Likelihood
  residualS: Severity
}

export function inherentScore(r: ScorableRisk): number {
  return riskScore(r.inherentL, r.inherentS)
}

export function residualScore(r: ScorableRisk): number {
  return riskScore(r.residualL, r.residualS)
}

export function residualBand(r: ScorableRisk): RiskBand {
  return bandFor(residualScore(r))
}
